import * as React from "react";
const SvgFiRrPersonPregnant = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M8.5 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m9.5 12c0 1.713-.946 4.512-1.055 4.826A1 1 0 0 1 16 20h-2v3a1 1 0 1 1-2 0v-3h-2v3a1 1 0 1 1-2 0v-3.188a3 3 0 0 1-1.249-.826 3 3 0 0 1-.728-2.357l.893-7.14a3.99 3.99 0 0 1 3.951-3.488c2.004 0 3.703 1.5 3.951 3.488l.006.048A5.48 5.48 0 0 1 18 14.501zm-2 0c0-1.5-.968-2.828-2.408-3.305a1 1 0 0 1-.678-.824l-.08-.634a1.99 1.99 0 0 0-1.967-1.738c-.997 0-1.843.747-1.967 1.736l-.192 1.534 2.846 1.897a1 1 0 1 1-1.11 1.664L8.43 13.487l-.423 3.387a.99.99 0 0 0 .242.786.99.99 0 0 0 .75.338h6.271c.309-1.006.729-2.583.729-3.5z"
    />
  </svg>
);
export default SvgFiRrPersonPregnant;
